import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "my-3 px-0 d-flex gap-1",
  style: {"border-bottom":"3px #ffd400 solid"}
}
const _hoisted_2 = { class: "card-body py-4" }
const _hoisted_3 = {
  class: "table align-middle table-row-dashed fs-6 gy-5",
  id: "table_accounts_requests"
}
const _hoisted_4 = { class: "text-start text-muted fw-bold fs-7 text-uppercase gs-0" }
const _hoisted_5 = { class: "" }
const _hoisted_6 = { class: "" }
const _hoisted_7 = { class: "" }
const _hoisted_8 = { class: "" }
const _hoisted_9 = { class: "" }
const _hoisted_10 = { class: "cell-color" }
const _hoisted_11 = { class: "cell-color" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = {
  key: 2,
  class: "fw-semibold text-gray-900"
}
const _hoisted_15 = { class: "d-flex align-items-center" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = {
  key: 1,
  class: "typeBadge"
}
const _hoisted_18 = { class: "cell-color" }
const _hoisted_19 = { class: "cell-color" }

import { ref, watch } from "vue";
import RebateService from "../services/RebateService";
import SimpleForm from "@/components/SimpleForm.vue";
import TableFooter from "@/components/TableFooter.vue";
import MsgPrompt from "@/core/plugins/MsgPrompt";


export default /*#__PURE__*/_defineComponent({
  __name: 'SchemaUsers',
  setup(__props, { expose: __expose }) {

const tabType = {
  direct: "direct",
  client: "client",
};

const directCriteria = ref({
  page: 1,
  size: 6,
});

const clientCriteria = ref({
  page: 1,
  size: 6,
});

const activeTab = ref(tabType.direct);

const schemaId = ref(0);
const isLoading = ref(true);
const schemaUsers = ref([] as any);
const rebateSchemaDetailShowRef = ref<any>(null);

const pageChange = (page: number) => {
  if (activeTab.value === tabType.direct) {
    directCriteria.value.page = page;
    fetchData(page);
  } else {
    clientCriteria.value.page = page;
    fetchData(page);
  }
};

const fetchData = async (selectedPage: number) => {
  isLoading.value = true;

  try {
    if (activeTab.value === tabType.direct) {
      directCriteria.value.page = selectedPage;
      const res = await RebateService.getSchemaUsedByDirectRule(
        schemaId.value,
        directCriteria.value
      );
      schemaUsers.value = res.data;
      directCriteria.value = res.criteria;
    } else {
      clientCriteria.value.page = selectedPage;
      const res = await RebateService.getSchemaUsedByClientRule(
        schemaId.value,
        clientCriteria.value
      );
      schemaUsers.value = res.data;
      clientCriteria.value = res.criteria;
    }

    isLoading.value = false;
  } catch (error: any) {
    MsgPrompt.error(error);
  }
};
const show = async (_id: number) => {
  schemaId.value = _id;
  activeTab.value = tabType.direct;
  fetchData(1);
  rebateSchemaDetailShowRef.value?.show();
};

const close = () => {
  rebateSchemaDetailShowRef.value?.hide();
};

watch(
  () => activeTab.value,
  () => {
    fetchData(1);
  }
);

__expose({ show });

return (_ctx: any,_cache: any) => {
  const _component_LoadingRing = _resolveComponent("LoadingRing")!
  const _component_NoDataBox = _resolveComponent("NoDataBox")!
  const _component_UserInfo = _resolveComponent("UserInfo")!
  const _component_IbSalesInfo = _resolveComponent("IbSalesInfo")!

  return (_openBlock(), _createBlock(SimpleForm, {
    ref_key: "rebateSchemaDetailShowRef",
    ref: rebateSchemaDetailShowRef,
    title: 'Schema Users',
    "is-loading": isLoading.value,
    width: 1300,
    "disable-footer": ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", {
          class: _normalizeClass(["basic-tab", { 'active-tab': activeTab.value === tabType.direct }]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (activeTab.value = tabType.direct))
        }, " Used by Direct Rules ", 2),
        _createElementVNode("span", {
          class: _normalizeClass(["basic-tab", { 'active-tab': activeTab.value === tabType.client }]),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (activeTab.value = tabType.client))
        }, " Used by Client Rules ", 2)
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("table", _hoisted_3, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", _hoisted_4, [
              _createElementVNode("th", _hoisted_5, _toDisplayString(_ctx.$t("fields.user")), 1),
              _createElementVNode("th", _hoisted_6, _toDisplayString(_ctx.$t("fields.role")), 1),
              _createElementVNode("th", _hoisted_7, _toDisplayString(_ctx.$t("fields.group")), 1),
              _createElementVNode("th", _hoisted_8, _toDisplayString(_ctx.$t("fields.type")), 1),
              _createElementVNode("th", _hoisted_9, _toDisplayString(_ctx.$t("fields.accountNumber")), 1),
              _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.$t("fields.ib")), 1),
              _createElementVNode("th", _hoisted_11, _toDisplayString(_ctx.$t("fields.salesWithCode")), 1)
            ])
          ]),
          (isLoading.value)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_12, [
                _createVNode(_component_LoadingRing)
              ]))
            : (!isLoading.value && schemaUsers.value.length === 0)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_13, [
                  _createVNode(_component_NoDataBox)
                ]))
              : (_openBlock(), _createElementBlock("tbody", _hoisted_14, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(schemaUsers.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("td", _hoisted_15, [
                        _createVNode(_component_UserInfo, {
                          url: "#",
                          user: item.user,
                          class: "me-2"
                        }, null, 8, ["user"])
                      ]),
                      _createElementVNode("td", null, _toDisplayString(_ctx.$t("type.accountRole." + item.role)), 1),
                      _createElementVNode("td", null, _toDisplayString(item.group), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.$t("type.account." + item.type)), 1),
                      _createElementVNode("td", null, [
                        (item.role == 400)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(item.tradeAccount.accountNumber), 1))
                          : (_openBlock(), _createElementBlock("span", _hoisted_17, "UID: " + _toDisplayString(item.uid), 1))
                      ]),
                      _createElementVNode("td", _hoisted_18, [
                        _createVNode(_component_IbSalesInfo, {
                          url: "#",
                          user: item.agentAccount.user,
                          uid: item.agentAccount.uid,
                          class: "me-2"
                        }, null, 8, ["user", "uid"])
                      ]),
                      _createElementVNode("td", _hoisted_19, [
                        _createVNode(_component_IbSalesInfo, {
                          url: "#",
                          user: item.salesAccount.user,
                          code: item.salesAccount.code,
                          uid: item.salesAccount.uid,
                          class: "me-2"
                        }, null, 8, ["user", "code", "uid"])
                      ])
                    ]))
                  }), 128))
                ]))
        ]),
        _createVNode(TableFooter, {
          onPageChange: pageChange,
          criteria: 
          activeTab.value === tabType.direct ? directCriteria.value : clientCriteria.value
        
        }, null, 8, ["criteria"])
      ])
    ]),
    _: 1
  }, 8, ["is-loading"]))
}
}

})